import { FC } from "react";
import ChatUI from "../../../components/chat/ChatUI";
import { PageContainer } from "../../../components/layout";
import { useDisplayOptions } from "../../../hooks/useDisplayOptions";
import useFeature from "../../../hooks/useFeature";
import { useGlobalOrganizationContext } from "../../../hooks/useGlobalOrganizationContext";
import OrganizationProcessExecutions from "./OrganizationProcessExecutions";

const OrganizationProcessExecutionsPage: FC<unknown> = () => {
  useDisplayOptions({});
  // TODO - filter executions by organization
  const { organization } = useGlobalOrganizationContext();
  const chatFeature = useFeature("chat");

  return (
    <PageContainer variant="full" GridProps={{ rowGap: 0 }}>
      <OrganizationProcessExecutions currentOrganization={organization} />
      {chatFeature && <ChatUI />}
    </PageContainer>
  );
};

export default OrganizationProcessExecutionsPage;
